import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'menu-item',
  name: '菜单项',
  icon: '项',
  group: '导航组件',
  description: '展示单个菜单入口及辅助信息',
  defaultProps: {
    title: '菜单项',
    subtitle: '',
    icon: '',
    badge: '',
    linkTarget: ''
  }
}
